import React from "react";
import styled from "@emotion/styled";
import StatusBadge from "./StatusBadge";

const HistoryValues = ({ status, vendor, date, reward = 0 }) => {
  function formatCustomDate(oldDate) {
    const date = new Date(oldDate);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12 || 12;

    return `${formattedDate} - ${hours}:${minutes}${ampm}`;
  }

  return (
    <HistoryContainer>
      <StatusBadge status={status} />
      <TextContainer>
        <DateText>{formatCustomDate(date)}</DateText>
        <VendorText>
          {vendor} - <StatusText status={status}>{status}</StatusText>
        </VendorText>
        {(status == "Successful" || status == "Paid") && (
          <ExtraContainer>
            <VendorText style={{ color: "rgba(100, 116, 139, 1)" }}>
              {status == "Successful" ? "You've earned" : "Payout amount"}
            </VendorText>
            <AmountText>
              {reward && reward.toString().startsWith("£")
                ? reward
                : `£${reward}`}
            </AmountText>
          </ExtraContainer>
        )}
      </TextContainer>
    </HistoryContainer>
  );
};

const HistoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
  gap: 8px;
  width: 100%;
`;

const LogoContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: ${(props) => {
    switch (props.status) {
      case "Successful":
        return "rgba(18, 124, 78, 0.1)";
      case "Tracking":
        return "rgba(244, 186, 52, 0.1)";
      case "Referral submitted":
        return "rgba(89, 84, 222, 0.1)";
      case "Unsuccessful":
        return "rgba(240, 70, 63, 0.1)";
      case "Paid":
        return "rgba(89, 84, 222, 0.1)";
      default:
        return "rgb(33, 37, 67)";
    }
  }};
`;

const TextContainer = styled.div`
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DateText = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
`;

const VendorText = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
`;

const AmountText = styled.span`
  color: rgba(118, 192, 101, 1);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
`;

const StatusText = styled.span`
  color: ${(props) => {
    switch (props.status) {
      case "Successful":
        return "rgba(18, 124, 78, 1)";
      case "Tracking":
        return "rgba(244, 186, 52, 1)";
      case "Referral submitted":
        return "rgba(89, 84, 222, 1)";
      case "Unsuccessful":
        return "rgba(240, 70, 63, 1)";
      case "Paid":
        return "rgba(89, 84, 222, 1)";
      default:
        return "rgb(33, 37, 67)";
    }
  }};
`;

const ExtraContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export default HistoryValues;
